"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const layers_1 = require("../../../services/layers");
const constants_1 = require("./constants");
const constants_2 = require("../../../utils/constants");
const createEditableTextLayer_1 = __importDefault(require("./createEditableTextLayer"));
const either_1 = require("../../../types/either");
const addCustomEditableTextLayer = (currentNumEditableTextLayers, currentDesignId, currentPrintable, activePage, maxZIndex) => {
  if (currentNumEditableTextLayers <= constants_1.MAX_EDITABLE_TEXT_LAYERS) {
    // If is a composite design we need to divide the size and the position by 2
    let layerX = constants_1.DEFAULT_POSITION_X;
    let layerWidth = constants_1.DEFAULT_SIZE_WIDTH;
    if (currentPrintable.isCompositeDesign) {
      layerWidth = layerWidth / 2;
      layerX = layerX / 2 + (activePage === layers_1.CoverageType.LEFT ? 0 : 0.5);
    }
    // Use first Editable Text layer id to know what layer we should create
    let firstEditableTextLayerId = `layer_${currentDesignId}_${layerX}x${constants_1.FIRST_DEFAULT_POSITION_Y}_${layerWidth}x${constants_1.DEAFULT_SIZE_HEIGHT}_editable_text_all`;
    if (currentPrintable.isCompositeDesign && activePage !== layers_1.CoverageType.LEFT) {
      firstEditableTextLayerId = firstEditableTextLayerId + constants_2.SHIFTED_RIGHT_APPENDIX;
    }
    const shouldCreateFirstEditableTextLayer = !currentPrintable.layers.find(l => l.id === firstEditableTextLayerId);
    const newEditableTextLayerData = {
      designId: currentDesignId,
      x: layerX,
      y: shouldCreateFirstEditableTextLayer ? constants_1.FIRST_DEFAULT_POSITION_Y : constants_1.SECOND_DEFAULT_POSITION_Y,
      width: layerWidth,
      height: constants_1.DEAFULT_SIZE_HEIGHT,
      zIndex: maxZIndex,
      isCompositeDesign: !!currentPrintable.isCompositeDesign,
      activePage
    };
    const newEditableTextLayer = (0, createEditableTextLayer_1.default)(newEditableTextLayerData);
    return (0, either_1.right)(newEditableTextLayer);
  } else {
    // This means we have the max number of Editable Text Layers
    return (0, either_1.left)(new Error(`Could not add more Editable Text Layers to the current printable: ${currentPrintable.id}, max is ${constants_1.MAX_EDITABLE_TEXT_LAYERS}`));
  }
};
exports.default = addCustomEditableTextLayer;